import React from 'react';
import moment from 'moment'

import { popUpClose } from '../../actions/pop-ups';
import AccountSwitcher from '../user/account-switcher';

import { useDispatch } from 'react-redux';

export default function ViewOrder({
    _id,
    transaction_id,
    first_name,
    last_name,
    email,
    address_1,
    address_2,
    city,
    region,
    country,
    postcode,
    payment,
    created_at
}){
  const dispatch = useDispatch();

  return(
    <div className="modal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              aria-hidden="true"
              onClick={(e) => {
                e.preventDefault()
                dispatch( popUpClose() )
              }}
            >&times;</button>
            <h4 className="modal-title">Order</h4>
          </div>
          <div className="modal-body">
            <div className="crud-form__container order-view-table">
              <table width="100%" className="pure-table pure-table-horizontal pure-table-striped">
                <tbody>
                  <tr>
                    <td><strong>Order ID:</strong></td>
                    <td>{_id.$oid}</td>
                  </tr>

                  <tr>
                    <td><strong>Name:</strong></td>
                    <td>{first_name} {last_name}</td>
                  </tr>

                  <tr>
                    <td><strong>Email:</strong></td>
                    <td><a href={'mailto:' + email}>{email}</a></td>
                  </tr>

                  <tr>
                    <td><strong>Address:</strong></td>
                    <td>
                      <div>
                        {
                          [
                            address_1,
                            address_2,
                            city,
                            region,
                            country,
                            postcode
                          ].map((x,i) => !!x ? <p key={i}>{x}</p> : '')
                        }
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td><strong>Payment status:</strong></td>
                    <td>
                      <p>{ payment }</p>
                      <p><a target='_blank' href={`https://www.braintreegateway.com/merchants/kqwcj2z3672zpb4r/transactions/${transaction_id}`}>Transaction</a></p>
                    </td>
                  </tr>

                  <tr>
                    <td><strong>Order placed:</strong></td>
                    <td>{moment(created_at).format('MMMM Do YYYY')}</td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={(e) => {
                e.preventDefault();
                dispatch( popUpClose() )
              }}
              className="btn button-cancel pure-button"
            >Close</button>
          </div>
        </div>
      </div>
    </div>
  )
}
